
/*
 * GLOBAL VARS
 */

//verificação de ambiente de homologação
if (window.location.href.indexOf("hml") != -1) {
    var url_base = "https://hml.thermas.com.br";
} else {
    var url_base = "https://www.thermas.com.br";
}
const CONF_URL_BASE = url_base;

const CONF_URL_TEST = "http://www.localhost:8080";
const CONF_VIEW_THEME = "site";
const CONF_URL_TICKET = "/ingresso";
const CONF_URL_PARTNER = "/parceiros";
const CONF_URL_FREEPASS = "/pacotes";
const CONF_URL_OUTLETS = "/pontos-de-venda";
const CONF_URL_TOURS = "/excursoes";

const CONF_GOOGLE_RECAPTHA_V3_SITE = '6Ld8hP8UAAAAALeKcOL8mdRqtJGj0WOSZg6A222O';